// Unpublished Work © 2025 Deere & Company.

import '../css/app.css';
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {OpsCenterRouter} from './OpsCenterRouter';
import {ThemeProvider, Themes} from '@deere/isg.component-library';
import {createRoot} from 'react-dom/client';
import {LandingPage} from './pages/LandingPage';
import {InitialProps, RenderAppProps} from './types/session-type';
import OhDeereBoundary from '@deere/oh-deere-boundary';

export function renderApp(renderAppProps: RenderAppProps) {
    const container = document.getElementById('app-mount') as HTMLElement;
    const root = createRoot(container);

    root.render(
        <React.StrictMode>
            <OhDeereBoundary {...renderAppProps.ohDeereProps}>
                <ThemeProvider theme={Themes.jddcEnterprise}>
                    <BrowserRouter>
                        <OpsCenterRouter renderAppProps={renderAppProps} />
                    </BrowserRouter>
                </ThemeProvider>
            </OhDeereBoundary>
        </React.StrictMode>
    );
}

export function renderLandingPage(initialProps: InitialProps) {
    const container = document.getElementById('app-mount') as HTMLElement;
    const root = createRoot(container);

    root.render(
        <React.StrictMode>
            <OhDeereBoundary {...initialProps.ohDeereProps}>
                <ThemeProvider theme={Themes.jddcEnterprise}>
                    <LandingPage />
                </ThemeProvider>
            </OhDeereBoundary>
        </React.StrictMode>
    );
}
